<div class="font-mono">
  <div class="overflow-x-auto break-words">
    @for (token of tokens(); track token.index) {
      <span
        [class.text-amber-600]="token.type === 'function'"
        [class.text-lime-600]="token.type === 'number'"
        [class.text-teal-600]="token.type === 'operator'"
        [class.text-violet-600]="token.type === 'variable'"
        [class.text-amber-800]="token.type === 'parenthesis'"
        >{{ token.text }}</span
      >
    }
  </div>
</div>
